import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { User, UserService } from '../../shared/public-api';

@Component({
  selector: 'admin-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [CommonModule, FormsModule, InputTextModule, ButtonModule],
  providers: [MessageService],
})
export class LoginComponent implements OnInit {
  userModel: User;
  isBrowser = false;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private userService: UserService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.userModel = new User();
  }

  login(): void {
    if (!this.isBrowser) {
      return;
    }
    this.userService.login(this.userModel).subscribe(
      (res) => {
        localStorage.setItem('token', res.token);
        this.router.navigate(['../articles'], { relativeTo: this.route });
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error,
        });
      }
    );
  }
}
